// Styles
import dynamic from 'next/dynamic';
import { useRef, useState } from 'react';
import { SearchContainer, StyledIconButton } from './style';

const SearchField = dynamic(() => import('./SearchInput'), {
  ssr: false,
});

export const Search = () => {
  const [isOpen, setIsOpen] = useState(false);

  // @ts-ignore
  const node = useRef(null);

  return (
    <SearchContainer ref={node}>
      <StyledIconButton onClick={() => setIsOpen(!isOpen)} name="search.svg" />
      {isOpen ? <SearchField node={node} setIsOpen={setIsOpen} isOpen={isOpen} /> : null}
    </SearchContainer>
  );
};
